import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import VSelect from 'vue-select'
import VueMoment from 'vue-moment'
import CoreuiVue from '@coreui/vue'
import VueGtm from '@gtm-support/vue2-gtm'
// import Affili from '@/plugins/affili'
import { i18n } from '@/plugins/i18n'
import VuePusher from '@/plugins/pusher'
import Helpers from '@/plugins/helpers'
import VueClipboard from 'vue-clipboard2'
import { abilitiesPlugin, Can } from '@casl/vue'
import { numberFormat } from '@/common/filters'
import { ApiServiceInit } from '@/services/api'
import CoreuiVueCharts from '@coreui/vue-chartjs'
import VueMobileDetection from 'vue-mobile-detection'
import CDataTable from '@/components/table/CDataTable'
import vueAwesomeCountdown from 'vue-awesome-countdown'
// import CDatePicker from '@/components/form/CDatePicker'
import { library } from '@fortawesome/fontawesome-svg-core'
import { IconsSet as icons } from '@/assets/icons/icons.js'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import { setI18nLanguageInServices } from '@/common/locales'
import CBreadcrumbRouter from '@/components/breadcrumb/CBreadcrumbRouter'
import {
    CSidebar,
    CSidebarNavItem,
    CSidebarNavDropdown,
    CFilterSidebar,
} from '@/components/sidebar'
import {
    CCustomInput,
    CCustomDatePicker,
    CCustomSelect,
    CCustomTextarea,
    CSelect,
    CSelect2,
    CCustomSearchableInput,
    CCustomImageInputFile,
    CCustomInputCheckbox,
} from '@/components/form'

import {
    Loading,
    FilterMe,
    SortMe,
    Message,
    RawContent,
    DetailsTable,
    CreateBtn,
    Avatar,
    BackBtn,
    EmptyPage,
    EmptyBox,
} from '@/components'


// form validate
import './services/form-validate'

// import custom global JavaScript codes
import './assets/js/custom.js'

// The moment variable must be 'moment' only
const moment = require('moment-jalaali')
import 'moment/locale/fa'


Vue.config.productionTip = false
Vue.config.performance = true

Vue.use(VueMobileDetection)

// Load plugins
Vue.use(abilitiesPlugin, store.getters.ability)
Vue.use(CoreuiVue)
Vue.use(Helpers, store)
Vue.use(VueMoment, {
    moment
})

Vue.use(vueAwesomeCountdown)
Vue.use(VueClipboard)
Vue.use(CoreuiVueCharts)
// Vue.use(Affili)
Vue.use(VueGtm, {
    id: 'GTM-MSHK5FR',
    vueRouter: router,
})

Vue.use(VuePusher, store)

// Load filters
Vue.filter('numberFormat', numberFormat)


// // Global components

// Ability
Vue.component('Can', Can)

// Add fontawsome icon component
Vue.component('FaIcon', FontAwesomeIcon)
library.add(icons)


Vue.component('Loading', Loading)
Vue.component('CSidebarNavItem', CSidebarNavItem)
Vue.component('CSidebarNavDropdown', CSidebarNavDropdown)
Vue.component('CSidebar', CSidebar)
Vue.component('CFilterSidebar', CFilterSidebar)
Vue.component('CDataTable', CDataTable)
Vue.component('CBreadcrumbRouter', CBreadcrumbRouter)
Vue.component('VSelect', VSelect)
Vue.component('CSelect', CSelect)
Vue.component('CSelect2', CSelect2)

Vue.component('FilterMe', FilterMe)
Vue.component('SortMe', SortMe)
Vue.component('Message', Message)
Vue.component('RawContent', RawContent)
Vue.component('DetailsTable', DetailsTable)
Vue.component('CreateBtn', CreateBtn)
Vue.component('Avatar', Avatar)
Vue.component('BackBtn', BackBtn)
Vue.component('EmptyPage', EmptyPage)
Vue.component('EmptyBox', EmptyBox)

// Custom form elements
Vue.component('CCustomInput', CCustomInput)
Vue.component('CCustomDatePicker', CCustomDatePicker)
Vue.component('CCustomSelect', CCustomSelect)
Vue.component('CCustomTextarea', CCustomTextarea)
Vue.component('CCustomSearchableInput', CCustomSearchableInput)
Vue.component('CCustomImageInputFile', CCustomImageInputFile)
Vue.component('CCustomInputCheckbox', CCustomInputCheckbox)

// Persian date picker
Vue.component('datePicker', VuePersianDatetimePicker)

Array.prototype.first = function () {
    return this.find(x => x !== undefined) ? this.find(x => x !== undefined) : {}
}

ApiServiceInit(store)

new Vue({
    router,
    store,
    ability: store.getters.ability,
    i18n,
    render: h => h(App),
    beforeCreate() {
        setI18nLanguageInServices(i18n.locale)
    },
}).$mount('#app')